import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import NoDataCreated from "../../../../../Components/NoDataCreated";
import ErrorPage from "../../../../../Components/ErrorPage";
import { goToTop } from "../../../../../Components/goToTop";
import {
  getLoginUserRoleName,
  UserRoleName,
} from "../../../../../Utils/LoginUserRoleName";
import Textarea from "../../../../../Components/TextArea";
import {
  createPlanCheckItem,
  createPlanCheckResponse,
  deletePlanCheckFile,
  deletePlanCheckItem,
  responsePlanCheck,
  sharePlanCheck,
  updatePlanCheckItem,
  uploadPlanCheckFiles,
} from "../../../../../Api/PlanCheck/PlanCheckApiServices";
import { getAllPlanChckList } from "../../../../../Controllers/Thunks/PlanCheckThunks";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../Controllers/hooks";
import { checkEmail, checkText } from "../../../../../Utils/Validator";
import { PlanCheck, PlanCheckItemList } from "../../../../../Controllers/Types/PlanCheck/PlanCheckType";
import DocumentViewModal from "../../../../../Components/DocumentViewModal";
import { documentFileExtension, imageFileExtension } from "../../../../../Api/FileConstant";
import { Tooltip } from "primereact/tooltip";
import { Image } from "primereact/image";
import { baseURL } from "../../../../../Api/ApiConstant";
import { InputText } from "primereact/inputtext";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import TextInput from "../../../../../Components/TextInput";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import TableActionLoader from "../../../../../Components/TableActionLoader";
import CustomTableLoader from "../../../../../Components/CustomTableLoader";
import FileActionLoader from "../../../../../Components/FileActionLoader";

const PlanCheckBasic: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const projectData = location.state?.projectData;
  const serviceId = Number(projectData.folder_id);
  const toast = useRef<Toast>(null);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");

  const dataLoading = useAppSelector((state) => state?.planCheckList?.loader);
  const error = useAppSelector((state) => state?.planCheckList?.errorDisplay);
  const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | "">("");
  const [initialDataLoading, setInitialDataLoading] = useState<boolean>(true);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const [planCheckData, setPlanCheckData] = useState<PlanCheck | null>(null);

  /* For Item */
  const [planCheckItemData, setPlanCheckItemData] = useState<PlanCheckItemList[]>([]);
  const [paginatedPlanCheckItemData, setPaginatedPlanCheckItemData] = useState<PlanCheckItemList[]>([]);
  const [selectedItemData, setSelectedItemData] = useState<PlanCheckItemList | null>(null);
  const [showItemModal, setShowItemModal] = useState<boolean>(false);
  const [itemCode, setItemCode] = useState<string>("");
  const [comment, setComment] = useState<string>("");
  const [itemCodeError, setItemCodeError] = useState<string>("");
  const [commentError, setCommentError] = useState<string>("");
  /*  */

  /* Pagination */
  const [first, setFirst] = useState<number>(0);
  const [rows, setRows] = useState<number>(10);

  const [isSignedAndPublishedByArc, setIsSignedAndPublishedByArc] = useState<boolean>(false);
  const [isSignedAndPublishedByBi, setIsSignedAndPublishedByBi] = useState<boolean>(false);
  const [itemUpdateHasChanges, setItemUpdateHasChanges] = useState<boolean>(false);
  const [responseFileDeleteLoadingId, setResponseFileDeleteLoadingId] = useState<number | null>(null);

  /* For architect response */
  const [showArcResponseModal, setShowArcResponseModal] = useState<boolean>(false);
  const [arcResponseNote, setArcResponseNote] = useState<string>('');
  const [arcResponseFiles, setArcResponseFiles] = useState<File[]>([]);
  const [arcResponseNoteError, setArcResponseNoteError] = useState<string>('');
  const [arcResponseFileError, setArcResponseFileError] = useState<string>('');
  const [arcResponseUpdateHasChanges, setArcResponseUpdateHasChanges] = useState<boolean>(false);

  /* For building inspector response */
  const [showBiResponseModal, setShowBiResponseModal] = useState<boolean>(false);
  const [biResponseNote, setBiResponseNote] = useState<string>('');
  const [statuses] = useState<string[]>(['Unsatisfactory', 'Satisfactory']);
  const [biResponseStatus, setBiResponseStatus] = useState<"Satisfactory" | "Unsatisfactory">('Unsatisfactory');
  const [biResponseNoteError, setBiResponseNoteError] = useState<string>('');
  const [biResponseStatusError, setBiResponseStatusError] = useState<string>('');
  const [biResponseUpdateHasChanges, setBiResponseUpdateHasChanges] = useState<boolean>(false);

  const [documentFilePath, setDocumentFilePath] = useState<string>("");
  const [showItemDocViewModal, setShowItemDocViewModal] = useState<boolean>(false);

  /* Mail */
  const [showMailModal, setShowMailModal] = useState<boolean>(false);
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [emailAddressError, setEmailAddressError] = useState<string>("");

  /* Download */
  const [isDownloading, setIsDownloading] = useState<boolean>(false);


  /* PERMISION HANDLER */
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const havePermissionDownloadFile = useCanEdit("Plan Check", "download_file");
  /*  */

  const dispatch = useAppDispatch();

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    planCheckDataGet();
  }, [location.state]);

  const planCheckDataGet = async () => {
    await dispatch(getAllPlanChckList(serviceId));
    setInitialDataLoading(false);
  }

  // this is get data from state list and set projectlist
  const plancheckList = useAppSelector((state) => state.planCheckList.planCheckList);

  useEffect(() => {
    if (location.state && location.state.data) {
      const options = plancheckList && plancheckList.length > 0;
      const data = location.state.data as PlanCheck;
      if (options) {
        const collect = plancheckList.filter((ex) => ex.id === data.id);
        if (collect && collect.length > 0) {
          setPlanCheckData(collect[0]);
        }
      }
    }
  }, [location.state, plancheckList]);

  useEffect(() => {
    if (planCheckData && planCheckData !== null) {
      if (planCheckData?.is_sign_report_by_arc && planCheckData?.is_published_by_arc) {
        setIsSignedAndPublishedByArc(true);
      } else {
        setIsSignedAndPublishedByArc(false);
      }

      if (planCheckData?.is_sign_report_by_bi && planCheckData?.is_published_by_bi) {
        setIsSignedAndPublishedByBi(true);
      } else {
        setIsSignedAndPublishedByBi(false);
      }
    } else {
      setIsSignedAndPublishedByArc(false);
      setIsSignedAndPublishedByBi(false);
    }
  }, [planCheckData]);

  useEffect(() => {
    const fetchUserRole = async () => {
      const roleName = await getLoginUserRoleName();
      setLoginUserRoleName(roleName);
    };

    fetchUserRole();
  }, []);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setRows(event.rows);
  };


  useEffect(() => {
    if (planCheckData && planCheckData !== null) {
      if (
        planCheckData?.check_type === "Basic" &&
        planCheckData?.item_list &&
        planCheckData?.item_list?.length > 0
      ) {
        setPlanCheckItemData(planCheckData?.item_list);
      } else {
        setPlanCheckItemData([]);
      }
    } else {
      setPlanCheckItemData([]);
    }
  }, [planCheckData]);

  useEffect(() => {
    const paginatedData = planCheckItemData.slice(first, first + rows);
    setPaginatedPlanCheckItemData(paginatedData);
  }, [planCheckItemData, first, rows]);


  /* **************************** plan check item ****************************** */
  useEffect(() => {
    if (selectedItemData && selectedItemData !== null) {
      if (comment !== selectedItemData?.comment) {
        setItemUpdateHasChanges(true);
      } else {
        setItemUpdateHasChanges(false);
      }
    }
  }, [selectedItemData, comment])

  const handleCloseItemModal = () => {
    setShowItemModal(false);
    handleResetItemFields();
  };

  const handleResetItemFields = () => {
    setComment("");
    setItemCodeError("");
    setCommentError("");
  };

  useEffect(() => {
    if (dataState === 'Add' && planCheckData && planCheckData !== null) {
      generateItemNumber();
    }
  }, [dataState, planCheckData]);

  const generateItemNumber = () => {
    let itemNumber = 0;

    itemNumber = planCheckData?.item_list?.length! + 1;
    setItemCode(itemNumber.toString());
  }

  const handleAddItem = () => {
    setDataState("Add");
    setShowItemModal(true);
    generateItemNumber();
  };

  // validations for items.
  function checkCredentialsForItem(): boolean {
    const item = checkText(itemCode, true, setItemCodeError);
    const coment = checkText(comment, true, setCommentError);

    return item && coment;
  }

  // clear message
  useEffect(() => {
    checkText(itemCode, false, setItemCodeError);
  }, [itemCode]);

  useEffect(() => {
    checkText(comment, false, setCommentError);
  }, [comment]);

  // handle api error
  function showAPIErrorItem(keyName: string, error: string): void {
    if (keyName === "item_code") {
      setItemCodeError(error);
    }

    if (keyName === "comment") {
      setCommentError(error);
    }
  }

  // item create database functions
  const handleCreateItem = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsForItem()) {
      setLoading(true);

      const data = await createPlanCheckItem(
        planCheckData?.id!,
        "Basic",
        serviceId!,
        null,
        itemCode,
        comment
      );

      setLoading(false);
      if (data.statusCode === 200) {
        planCheckDataGet();

        handleResetItemFields();
        generateItemNumber();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item added successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorItem(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error creating the item.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleEditItem = (data: PlanCheckItemList) => {
    setDataState("Edit");
    setShowItemModal(true);

    if (data) {
      setItemCode(data?.item_code || "");
      setComment(data?.comment || "");
      setSelectedItemData(data);
    } else {
      setSelectedItemData(null);
      setItemCode("");
      setComment("");
    }
  };

  // item update database functions
  const handleUpdateItem = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsForItem()) {
      setLoading(true);

      const data = await updatePlanCheckItem(
        planCheckData?.id!,
        itemCode,
        comment,
        "Open",
        selectedItemData?.id!
      );

      setLoading(false);
      if (data.statusCode === 200) {
        planCheckDataGet();

        handleCloseItemModal();
        handleResetItemFields();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item updated successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorItem(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the item.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleDeleteItem = (itemId: number) => {
    confirmDialog({
      message: "Are you sure you want to delete this item?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteItem(itemId),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteItem = async (itemId: number) => {
    setDeleteLoading(true);
    const result = await deletePlanCheckItem(itemId);

    setDeleteLoading(false);
    if (result.statusCode === 200) {
      planCheckDataGet();
      handleCloseItemModal();

      setTimeout(() => {
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Item deleted successfully.",
            life: 3000,
          });
        }
      }, 500);
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the item.",
          life: 3000,
        });
      }
    }
  };

  const itemModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        {dataState} item detail
      </h5>

      {dataState === "Edit" ? (
        <React.Fragment>
          {deleteLoading ? (
            <TableActionLoader className="is_modal_loader" />
          ) : (
            <button
              type="button"
              className="close_modal_btn p-ripple"
              onClick={() => handleDeleteItem(selectedItemData?.id!)}
            >
              <i className="bi bi-trash3"></i>
              <Ripple />
            </button>
          )}
        </React.Fragment>
      ) : (
        <button
          type="button"
          className="close_modal_btn p-ripple"
          onClick={handleCloseItemModal}
        >
          <i className="bi bi-x-circle"></i>
          <Ripple />
        </button>
      )}
    </div>
  );

  const itemModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseItemModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Save & Next" : "Update"}`}
        onClick={dataState === "Add" ? handleCreateItem : handleUpdateItem}
        loading={loading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && !itemUpdateHasChanges}
      />
    </div>
  );
  /* *************************************************************************** */

  const handleNavigateReport = () => {
    navigate(
      `/project/detail/default-service/pre-commencement/plan-check/report`,
      { state: { projectData: projectData, planCheckData: planCheckData } }
    );
  };


  /* **************************** For architect response ************************ */
  useEffect(() => {
    if (planCheckData && planCheckData !== null) {
      if (dataState === 'Edit' && selectedItemData && selectedItemData !== null) {
        const updatedItemData = planCheckData?.item_list?.find(item => item?.id === selectedItemData?.id);

        setSelectedItemData(updatedItemData || null);
      }
    }

  }, [dataState, selectedItemData, planCheckData]);

  useEffect(() => {
    if (selectedItemData && selectedItemData !== null) {
      if (arcResponseNote !== selectedItemData?.architect_response) {
        setArcResponseUpdateHasChanges(true);
      } else {
        setArcResponseUpdateHasChanges(false);
      }
    }
  }, [selectedItemData, arcResponseNote]);

  const handleCloseArcResponseModal = () => {
    setShowArcResponseModal(false);
    handleResetArcResponseFields();
    handleResetArcResponseErrors();
    setSelectedItemData(null);
  }

  const handleResetArcResponseFields = () => {
    setArcResponseNote('');
    setArcResponseFiles([]);
  }

  const handleResetArcResponseErrors = () => {
    setArcResponseNoteError('');
    setArcResponseFileError('');
  }

  const handleAddArcResponse = (item: PlanCheckItemList) => {
    setDataState('Add');
    setShowArcResponseModal(true);
    setSelectedItemData(item);

    handleResetArcResponseFields();
    handleResetArcResponseErrors();
  }

  // Response validations.
  function checkCredentialsArcResponse(): boolean {
    const item = checkText(arcResponseNote, true, setArcResponseNoteError);

    return item;
  }

  // clear message
  useEffect(() => {
    checkText(arcResponseNote, false, setArcResponseNoteError);
  }, [arcResponseNote]);

  // handle api error
  function showAPIErrorArcResponse(keyName: string, error: string): void {
    if (keyName === "response") {
      setArcResponseNoteError(error);
    }
  }

  const handleCreateResponseByArc = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsArcResponse()) {
      setLoading(true);

      const data = await responsePlanCheck(
        planCheckData?.id!,
        selectedItemData?.id!,
        arcResponseNote,
        "Architect",
        null
      );

      // files uploading
      if (arcResponseFiles && arcResponseFiles.length > 0) {
        const upload = await uploadPlanCheckFiles(
          planCheckData?.id!,
          selectedItemData?.id!,
          arcResponseFiles
        );

        if (upload.statusCode !== 200) {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "There was an error Uploading files.",
              life: 3000,
            });
          }
        }
      }

      setLoading(false);

      if (data.statusCode === 200) {
        planCheckDataGet();
        handleCloseArcResponseModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "The response was successfully submitted.",
            life: 2000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorArcResponse(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error submitting the response.",
            life: 3000,
          });
        }
      }
    }
  }

  const handleEditArcResponse = (item: PlanCheckItemList) => {
    if (item) {
      setDataState('Edit');
      setShowArcResponseModal(true);
      setSelectedItemData(item);

      setArcResponseNote(item?.architect_response!);
    }
  }

  const handleUpdateResponseByArc = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsArcResponse()) {
      setLoading(true);

      const data = await responsePlanCheck(
        planCheckData?.id!,
        selectedItemData?.id!,
        arcResponseNote,
        "Architect",
        null
      );

      // files uploading
      if (arcResponseFiles && arcResponseFiles.length > 0) {
        const upload = await uploadPlanCheckFiles(
          planCheckData?.id!,
          selectedItemData?.id!,
          arcResponseFiles
        );

        if (upload.statusCode !== 200) {
          if (toast.current) {
            toast.current.show({
              severity: "error",
              summary: "Failed",
              detail: "There was an error Uploading files.",
              life: 3000,
            });
          }
        }
      }

      setLoading(false);
      if (data.statusCode === 200) {
        planCheckDataGet();
        handleCloseArcResponseModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "The response was successfully updated.",
            life: 2000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorArcResponse(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the response.",
            life: 3000,
          });
        }
      }
    }
  }

  const arcResponseModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        {dataState} response
      </h5>
      <button type="button" className="close_modal_btn p-ripple"
        onClick={handleCloseArcResponseModal}>
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  )

  const arcResponseModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseArcResponseModal}
      />

      <Button
        label={`${loading ? 'Processing' : dataState === 'Add' ? 'Submit' : 'Update'}`}
        onClick={dataState === 'Add' ? handleCreateResponseByArc : handleUpdateResponseByArc}
        loading={loading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && arcResponseFiles?.length === 0 && !arcResponseUpdateHasChanges}
      />
    </div>
  )

  const handleDeleteResponseFile = (fileId: number) => {
    confirmDialog({
      message: "Are you sure you want to delete this file?",
      header: "Confirm the deletion",
      icon: "bi bi-info-circle",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      accept: () => deleteResponseFile(fileId),
      dismissableMask: true,
      resizable: false,
      draggable: false,
    });
  };

  const deleteResponseFile = async (fileId: number) => {
    setResponseFileDeleteLoadingId(fileId);
    const result = await deletePlanCheckFile(fileId);

    setResponseFileDeleteLoadingId(null);

    if (result.statusCode === 200) {
      planCheckDataGet();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "File deleted successfully.",
          life: 2000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the file.",
          life: 3000,
        });
      }
    }
  };

  const handleUploadResponseFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const filesArray = Array.from(event.target.files);
      setArcResponseFiles((prev) => [...prev, ...filesArray]);
    }
  };

  const handleRemoveResponseFile = (fileIndex: number) => {
    setArcResponseFiles((prev) => prev.filter((_, i) => i !== fileIndex));
  };
  /* *************************************************************************** */


  /* ********************** For building inspector response ******************** */
  useEffect(() => {
    if (selectedItemData && selectedItemData !== null) {
      const mappedStatus = selectedItemData?.status === "Closed" ? "Satisfactory" : "Unsatisfactory";

      if (biResponseNote !== null && biResponseNote !== selectedItemData?.building_inspector_response) {
        setBiResponseUpdateHasChanges(true);
      } else if (biResponseStatus !== mappedStatus) {
        setBiResponseUpdateHasChanges(true);
      }
      else {
        setBiResponseUpdateHasChanges(false);
      }
    }
  }, [selectedItemData, biResponseNote, biResponseStatus]);

  const handleCloseBiResponseModal = () => {
    setShowBiResponseModal(false);
    handleResetBiResponseFields();
    handleResetBiResponseErrors();
    setSelectedItemData(null);
  }

  const handleResetBiResponseFields = () => {
    setBiResponseNote('');
    setBiResponseStatus('Unsatisfactory');
  }

  const handleResetBiResponseErrors = () => {
    setBiResponseNoteError('');
    setBiResponseStatusError('');
  }

  const handleAddBiResponse = (item: PlanCheckItemList) => {
    setDataState('Add');
    setShowBiResponseModal(true);
    setSelectedItemData(item);

    handleResetBiResponseFields();
    handleResetBiResponseErrors();
  }

  // Response validations.
  function checkCredentialsBIResponse(): boolean {
    const item = checkText(biResponseNote, false, setBiResponseNoteError);

    return item;
  }

  // clear message
  useEffect(() => {
    checkText(biResponseNote, false, setBiResponseNoteError);
  }, [biResponseNote]);

  // handle api error
  function showAPIErrorBIResponse(keyName: string, error: string): void {
    if (keyName === "response") {
      setBiResponseNoteError(error);
    }
  }

  const handleCreateResponseByBi = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsBIResponse()) {
      setLoading(true);

      const data = await responsePlanCheck(
        planCheckData?.id!,
        selectedItemData?.id!,
        biResponseNote,
        "Building Inspector",
        biResponseStatus
      );

      setLoading(false);
      if (data.statusCode === 200) {
        planCheckDataGet();
        handleCloseBiResponseModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "The response was successfully submitted.",
            life: 2000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorBIResponse(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error submitting the response.",
            life: 3000,
          });
        }
      }
    }
  }

  const handleEditBiResponse = (item: PlanCheckItemList) => {
    if (item) {
      setDataState('Edit');
      setShowBiResponseModal(true);
      setSelectedItemData(item);

      setBiResponseNote(item?.building_inspector_response === 'N/A' ? '' : item?.building_inspector_response!);
      setBiResponseStatus(item?.status && item?.status === 'Open' ? 'Unsatisfactory' : 'Satisfactory');
    }
  }

  const handleUpdateResponseByBi = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsBIResponse()) {
      setLoading(true);
      const data = await responsePlanCheck(
        planCheckData?.id!,
        selectedItemData?.id!,
        biResponseNote,
        "Building Inspector",
        biResponseStatus
      );

      setLoading(false);
      if (data.statusCode === 200) {
        planCheckDataGet();
        handleCloseBiResponseModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "The response was successfully updated.",
            life: 2000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorBIResponse(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error updating the response.",
            life: 3000,
          });
        }
      }
    }
  }

  const biResponseModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">
        {dataState} response
      </h5>
      <button type="button" className="close_modal_btn p-ripple"
        onClick={handleCloseBiResponseModal}>
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  )

  const biResponseModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseBiResponseModal}
      />

      <Button
        label={`${loading ? 'Processing' : dataState === 'Add' ? 'Reply' : 'Update'}`}
        onClick={dataState === 'Add' ? handleCreateResponseByBi : handleUpdateResponseByBi}
        loading={loading}
        className="custom_btn primary"
        disabled={dataState === 'Edit' && !biResponseUpdateHasChanges}
      />
    </div>
  )
  /* *************************************************************************** */


  const handleCloseFileViewModal = () => {
    setShowItemDocViewModal(false);
  };

  const handleViewDocument = (filePath: string) => {
    if (filePath && filePath !== "") {
      setShowItemDocViewModal(true);
      setDocumentFilePath(filePath);
    } else {
      setDocumentFilePath("");
    }
  };



  /* ******************************** Download ********************************* */
  const handleDownloadReport = async () => {
    if (isDownloading) return;
    // const reportPath = baseURL +"/"+ planCheckData?.file_download_path;
    const reportPath = planCheckData?.file_download_path;
    if (!reportPath) {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "File not found!",
          life: 3000,
        });
      }
      return;
    }

    setIsDownloading(true);

    setTimeout(async () => {
      try {
        const response = await fetch(reportPath);

        if (!response.ok) {
          throw new Error("Failed to fetch the file.");
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = reportPath.split("/").pop() || "plan check report.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "File downloaded successfully.",
            life: 3000,
          });
        }
      } catch (error) {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "Error downloading the file",
            life: 3000,
          });
        }
      } finally {
        setIsDownloading(false);
      }
    }, 500);
  };

  const handleViewReportDocument = () => {
    if (planCheckData?.file_download_path) {
      setShowItemDocViewModal(true);
      setDocumentFilePath(planCheckData?.file_download_path);
    }
  };
  /* *************************************************************************** */


  /* *********************************** Mail ********************************** */
  const handleCloseMailModal = () => {
    setShowMailModal(false);
    setEmailAddress("");
  };

  const handleAddMail = () => {
    setShowMailModal(true);
  };

  // need to add email for send report.
  // validations.
  function checkCredentialsEmail(): boolean {
    const mail = checkEmail(emailAddress, true, setEmailAddressError);
    return mail;
  }

  // clear message
  useEffect(() => {
    checkEmail(emailAddress, false, setEmailAddressError);
  }, [emailAddress]);

  // database error set message.
  function showAPIErrorEmail(keyName: string, error: string): void {
    if (keyName === "email") {
      setEmailAddressError(error);
    }
  }

  // send mail database functions.
  const handleSendMail = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentialsEmail()) {
      setLoading(true);
      const data = await sharePlanCheck(planCheckData?.id!, emailAddress);

      setLoading(false);
      if (data.statusCode === 200) {
        planCheckDataGet();
        handleCloseMailModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Email sent successfully.",
            life: 3000,
          });
        }
      } else if (data.statusCode === 422) {
        // database error
        Object.entries(data.errors ?? []).map(([key, value], index) =>
          showAPIErrorEmail(key, value[0])
        );
      } else {
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error sending the email.",
            life: 3000,
          });
        }
      }
    }
  };

  const mailModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Send report via mail</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseMailModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const mailModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Cancel"
        className="custom_btn secondary"
        onClick={handleCloseMailModal}
      />
      <Button
        loading={loading}
        label={`${loading ? "Sending" : "Send"}`}
        className="custom_btn primary"
        onClick={handleSendMail}
      />
    </div>
  );
  /* *************************************************************************** */


  /* ********************** Response create by architect *********************** */
  const handleCreateResponse = () => {
    confirmDialog({
      message: 'Are you sure, Do you want to create a new document to respond to the plan check?',
      header: 'Confirm the Publishion',
      icon: 'bi bi-info-circle',
      defaultFocus: 'accept',
      acceptClassName: 'p-button-danger',
      accept: () => createResponse(),
      resizable: false,
      draggable: false,
      dismissableMask: true
    });
  }

  const createResponse = async () => {
    const data = await createPlanCheckResponse(planCheckData?.id!);

    if (data.statusCode === 200) {
      planCheckDataGet();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "The response was successfully created.",
          life: 3000,
        });
      }
      setTimeout(() => {
        navigate(`/project/detail/default-service/pre-commencement/plan-check/list`, { state: { data: projectData } });
      }, 500);
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "An error occurred while creating the response.",
          life: 3000,
        });
      }
    }
  }
  /* *************************************************************************** */


  /* **************************** Common functions ***************************** */
  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content full_screen_view">
        {dataLoading && initialDataLoading ? (
          <div className="loading_container">
            <ProgressSpinner
              className="progresscircle custom"
              style={{ width: "50px", height: "50px", stroke: "#8953D7" }}
              strokeWidth="8"
              fill="var(--surface-ground)"
              animationDuration="1s"
            />
          </div>
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area with_responsive">
              <ul className="page_breadcrumb">
                <li
                  className="page_breadcrumb_item has_child has_link"
                  onClick={() => navigate(-3)}
                >
                  {projectData?.job_number}: {projectData?.address}
                </li>
                <li className="page_breadcrumb_item has_child">
                  {projectData?.folder}
                </li>
                <li
                  className="page_breadcrumb_item has_child has_link"
                  onClick={() => navigate(-2)}
                >
                  {projectData?.feature_name}
                </li>
                <li
                  className="page_breadcrumb_item has_child has_link"
                  onClick={() => navigate(-1)}
                >
                  Plan check list
                </li>
                <li className="page_breadcrumb_item active">
                  Plan check - Basic
                </li>
              </ul>

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_header_area mt-sm-3 mt-3 justify-content-end">
              <div className="page_action_area">
                {planCheckData?.file_download_path !== null && (
                  <React.Fragment>
                    {havePermissionDownloadFile && (
                      <button
                        className="add_data_link_btn p-ripple"
                        onClick={handleDownloadReport}
                        disabled={isDownloading}
                      >
                        {isDownloading ? (
                          <ProgressSpinner
                            style={{ width: "20px", height: "20px" }}
                            strokeWidth="5"
                            fill="none"
                            animationDuration="1s"
                            className="spin_loader"
                          />
                        ) : (
                          <i className="bi bi-download"></i>
                        )}
                        <span>{isDownloading ? "Downloading" : "Download"}</span>
                        <Ripple />
                      </button>
                    )}

                    {loginUserRoleName === 'building inspector' && (
                      <button
                        className="add_data_link_btn p-ripple"
                        onClick={handleAddMail}
                      >
                        <i className="bi bi-envelope"></i>
                        <span>Send</span>
                        <Ripple />
                      </button>
                    )}
                  </React.Fragment>
                )}

                {loginUserRoleName === 'architect' && (
                  <React.Fragment>
                    {planCheckData?.is_created_responce === null && planCheckData?.stage_for === 'Original' && (
                      <button
                        className="add_data_link_btn p-ripple"
                        onClick={handleCreateResponse}
                      >
                        <i className="bi bi-reply"></i>
                        <span>Response</span>
                        <Ripple />
                      </button>
                    )}
                  </React.Fragment>
                )}

                <button
                  className="add_data_link_btn p-ripple"
                  onClick={handleNavigateReport}
                >
                  <i className="bi bi-eye"></i>
                  <span>Preview</span>
                  <Ripple />
                </button>

                {isSignedAndPublishedByBi === false && isSignedAndPublishedByArc === false && loginUserRoleName === "building inspector" && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddItem}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add item</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_main_content_section no_header">
              {paginatedPlanCheckItemData && paginatedPlanCheckItemData?.length > 0 ? (
                <div className="pck_track_list_area">
                  {dataLoading && (
                    <CustomTableLoader />
                  )}

                  <div className="table-responsive pck_track_list_table_area">
                    <table className="table pck_track_list_table">
                      <thead>
                        <tr>
                          <th style={{ width: "100%" }}>Item detail</th>
                        </tr>
                      </thead>

                      <tbody>
                        {paginatedPlanCheckItemData?.map((item) => {
                          return (
                            <tr key={item?.id} className="part_item_row">
                              <td style={{ width: "100%" }}>
                                <div className="item_list_wrapper">
                                  <div className={`pck_track_list_item_area ${item?.status === "Open" ? "warning" : "success"}`}>
                                    <div className="pck_track_list_item_header">
                                      <span className="item_code">
                                        {item?.item_code}.
                                      </span>

                                      <span className="item_cmt">
                                        {item?.comment}
                                      </span>
                                    </div>

                                    <div className="response_display_area">
                                      {item?.architect_response && item?.architect_response !== null && (
                                        <div className="response_input_area mb-0 readonly">
                                          <label>Architect Response :&nbsp;</label>

                                          <p className="first_letter_capitalized">
                                            {item?.architect_response ? (
                                              item?.architect_response
                                            ) : (
                                              <span className="text_empty text_italic">N/A</span>
                                            )}
                                          </p>

                                          {item?.file_list && item?.file_list?.length > 0 && (
                                            <div className="response_file_area mt-3 pb-0">
                                              <div className="checklist_img_container">
                                                {item?.file_list?.map((file, index) => (
                                                  <div
                                                    className="note_image_container response_image_container"
                                                    key={file?.id}
                                                  >
                                                    {file?.extension === "pdf" ? (
                                                      <div
                                                        className="response_doc_file_container"
                                                        onClick={() => handleViewDocument(baseURL + file?.path!)}
                                                      >
                                                        <i className="bi bi-file-earmark-pdf"></i>
                                                      </div>
                                                    ) : (
                                                      <Image
                                                        src={baseURL + file?.path!}
                                                        alt={`${index + 1}`}
                                                        className="note_img response_image"
                                                        preview
                                                      />
                                                    )}
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}

                                      {loginUserRoleName === 'architect' && (
                                        <React.Fragment>
                                          {item?.building_inspector_response && item?.building_inspector_response !== null && isSignedAndPublishedByBi === true && (
                                            <div className="response_input_area readonly mb-0">
                                              <label className="text-danger">Building Inspector Response :&nbsp;</label>

                                              <p className={`first_letter_capitalized ${(item?.building_inspector_response === 'N/A' && item?.status === 'Open') ? 'text_empty text_italic' : ''}`}>
                                                {item?.status === 'Closed' && item?.building_inspector_response === 'N/A' ? 'Satisfactory' :
                                                  item?.building_inspector_response ? (
                                                    item?.building_inspector_response
                                                  ) : (
                                                    <span className="text_empty text_italic">N/A</span>
                                                  )
                                                }
                                              </p>
                                            </div>
                                          )}
                                        </React.Fragment>
                                      )}

                                      {loginUserRoleName === 'building inspector' && (
                                        <React.Fragment>
                                          {item?.building_inspector_response && item?.building_inspector_response !== null && (
                                            <div className="response_input_area readonly mb-0">
                                              <label className="text-danger">Building Inspector Response :&nbsp;</label>

                                              <p className={`first_letter_capitalized ${(item?.building_inspector_response === 'N/A' && item?.status === 'Open') ? 'text_empty text_italic' : ''}`}>
                                                {item?.status === 'Closed' && item?.building_inspector_response === 'N/A' ? 'Satisfactory' :
                                                  item?.building_inspector_response ? (
                                                    item?.building_inspector_response
                                                  ) : (
                                                    <span className="text_empty text_italic">N/A</span>
                                                  )
                                                }
                                              </p>
                                            </div>
                                          )}
                                        </React.Fragment>
                                      )}
                                    </div>

                                    {loginUserRoleName === 'architect' ? (
                                      <React.Fragment>
                                        {planCheckData?.stage_for === 'Response' && isSignedAndPublishedByArc === false && (
                                          <div className="pck_track_list_item_footer mt-3">
                                            <div className="pck_track_list_item_btn_group">
                                              <button
                                                className={`table_action_btn white bordered p-ripple`}
                                                onClick={() => item?.architect_response === null ? handleAddArcResponse(item) : handleEditArcResponse(item)}
                                              >
                                                {item?.architect_response === null ? '' : 'Edit '}Response
                                                <Ripple />
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    ) : loginUserRoleName === 'building inspector' ? (
                                      <React.Fragment>
                                        {isSignedAndPublishedByBi === false && isSignedAndPublishedByArc === false && (
                                          <div className="pck_track_list_item_footer mt-3">
                                            <div className="pck_track_list_item_btn_group">
                                              <button
                                                className={`table_action_btn white bordered p-ripple`}
                                                onClick={() => handleEditItem(item)}
                                              >
                                                Edit
                                                <Ripple />
                                              </button>
                                            </div>
                                          </div>
                                        )}

                                        {isSignedAndPublishedByArc === true && isSignedAndPublishedByBi === false && (
                                          <div className="pck_track_list_item_footer">
                                            <div className="pck_track_list_item_btn_group">
                                              <button
                                                className={`table_action_btn white bordered p-ripple`}
                                                onClick={() => item?.building_inspector_response === null ? handleAddBiResponse(item) : handleEditBiResponse(item)}
                                              >
                                                {item?.building_inspector_response === null ? '' : 'Edit '}Response
                                                <Ripple />
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    ) : null}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination_area">
                    <Paginator
                      first={first}
                      rows={rows}
                      totalRecords={planCheckItemData?.length}
                      rowsPerPageOptions={[10, 20, 30]}
                      onPageChange={onPageChange}
                    />
                  </div>
                </div>
              ) : (
                <NoDataCreated message={`No item has been created. ${loginUserRoleName === 'building inspector' ? 'To create the item click on add button.' : ''}`} />
              )}
            </div>
          </div>
        )}
      </div>


      {/* Plan check item modal */}
      <Dialog
        visible={showItemModal}
        headerClassName="custom_modal_header"
        header={itemModalHeader}
        footer={itemModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_md"
        onHide={handleCloseItemModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Item code */}
              <div className="col-12 col-sm-6">
                <div className="page_form_group">
                  <label htmlFor="itemCode" className="custom_form_label">
                    Item code&nbsp;
                    <small>
                      {dataState === "Add"
                        ? "(Auto generated)"
                        : "(Can't modify)"}
                    </small>
                  </label>
                  <InputText
                    key={`itemCode`}
                    id="itemCode"
                    value={itemCode}
                    className="custom_form_input"
                    placeholder="Eg: 1"
                    disabled
                  />

                  {itemCodeError && (
                    <small className="form_error_msg">
                      {itemCodeError}
                    </small>
                  )}
                </div>
              </div>

              {/* Note */}
              <div className="col-12">
                <Textarea
                  id="comment"
                  label="Comment"
                  labelHtmlFor="comment"
                  required={true}
                  value={comment}
                  placeholder="Comment"
                  formGroupClassName="mb-1"
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value)}
                  error={commentError}
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Plan check architect response modal */}
      <Dialog
        visible={showArcResponseModal}
        headerClassName="custom_modal_header"
        header={arcResponseModalHeader}
        footer={arcResponseModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseArcResponseModal}>
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            {selectedItemData && selectedItemData !== null && (
              <div className="row">
                {/* Item */}
                <div className="col-12">
                  <div className="page_form_group">
                    <h6 className="data_label">
                      {selectedItemData?.item_code}.&nbsp;{selectedItemData?.comment}
                    </h6>
                  </div>
                </div>

                {/* Response note */}
                <div className="col-12">
                  <Textarea
                    id="arcResponseNote"
                    label="Response note"
                    labelHtmlFor="arcResponseNote"
                    required={true}
                    value={arcResponseNote}
                    placeholder="Enter response note"
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setArcResponseNote(e.target.value)}
                    error={arcResponseNoteError}
                  />
                </div>

                {/* Response Files */}
                <div className="col-12">
                  <div className="page_form_group">
                    <label htmlFor="" className="custom_form_label">Files</label>

                    <div className="checklist_img_container mt-2 mb-1">
                      {dataState === 'Edit' && (
                        <React.Fragment>
                          {selectedItemData?.file_list && selectedItemData?.file_list?.length > 0 && (
                            <React.Fragment>
                              {selectedItemData?.file_list?.map((file, index) => (
                                <div className="note_image_container response_image_container" key={file?.id}>
                                  {responseFileDeleteLoadingId === file?.id ? (
                                    <FileActionLoader />
                                  ) : (
                                    <React.Fragment>
                                      {file?.extension === "pdf" ? (
                                        <div
                                          className="response_doc_file_container"
                                          onClick={() => handleViewDocument(baseURL + file?.path!)}
                                        >
                                          <i className="bi bi-file-earmark-pdf"></i>
                                        </div>
                                      ) : (
                                        <Image
                                          src={baseURL + file?.path!}
                                          alt={`${index + 1}`}
                                          className="note_img response_image"
                                          preview
                                        />
                                      )}
                                    </React.Fragment>
                                  )}

                                  <button
                                    className="img_clear_btn p-ripple"
                                    onClick={() => handleDeleteResponseFile(file?.id!)}
                                  >
                                    <i className="bi bi-x"></i>
                                  </button>
                                </div>
                              ))}
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      )}

                      {arcResponseFiles && arcResponseFiles?.length > 0 && (
                        <React.Fragment>
                          {arcResponseFiles.map((file, index) => {
                            const fileExtension = file.name?.split(".").pop()?.toLowerCase();
                            return (
                              <div
                                className="note_image_container response_image_container"
                                key={index}
                              >
                                {fileExtension === "pdf" ? (
                                  <div
                                    className="response_doc_file_container"
                                    onClick={() => handleViewDocument(URL.createObjectURL(file))}
                                  >
                                    <i className="bi bi-file-earmark-pdf"></i>
                                  </div>
                                ) : (
                                  <Image
                                    src={URL.createObjectURL(file)}
                                    alt={`${index + 1}`}
                                    className="note_img response_image"
                                    preview
                                  />
                                )}

                                <button
                                  className="img_clear_btn p-ripple"
                                  onClick={() => handleRemoveResponseFile(index)}
                                >
                                  <i className="bi bi-x"></i>
                                </button>
                              </div>
                            );
                          })}
                        </React.Fragment>
                      )}

                      <Tooltip target={`.img_upload_label`} />

                      <label
                        htmlFor="arcResponseFiles"
                        className="img_upload_label p-ripple"
                        data-pr-tooltip="Upload files"
                        data-pr-position="right"
                      >
                        <i className="bi bi-upload"></i>
                        <input
                          id="arcResponseFiles"
                          multiple
                          type="file"
                          accept={documentFileExtension + ', ' + imageFileExtension}
                          onChange={handleUploadResponseFiles}
                        />
                        <Ripple />
                      </label>
                    </div>

                    <span className="file_upload_info pt-1">
                      <i className="bi bi-info-circle"></i> Acceptable file format : {documentFileExtension + ', ' + imageFileExtension}
                    </span>

                    {arcResponseFileError &&
                      <small className="form_error_msg">{arcResponseFileError}</small>
                    }
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Plan check building inspector response modal */}
      <Dialog
        visible={showBiResponseModal}
        headerClassName="custom_modal_header"
        header={biResponseModalHeader}
        footer={biResponseModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseBiResponseModal}>
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            {selectedItemData && selectedItemData !== null && (
              <div className="row">
                {/* Item */}
                <div className="col-12">
                  <div className="page_form_group">
                    <h6 className="data_label">
                      {selectedItemData?.item_code}.&nbsp;{selectedItemData?.comment}
                    </h6>
                  </div>
                </div>

                {/* Architect response */}
                {selectedItemData?.architect_response && selectedItemData?.architect_response !== null && (
                  <div className="col-12">
                    <div className="page_form_group">
                      <div className="response_input_area my-0 readonly bg_visible">
                        <label>Architect Response :{" "}</label>

                        <p className="first_letter_capitalized">
                          {selectedItemData?.architect_response ? (
                            selectedItemData?.architect_response
                          ) : (
                            <span className="text_empty text_italic">N/A</span>
                          )}
                        </p>

                        {selectedItemData?.file_list && selectedItemData?.file_list?.length > 0 && (
                          <div className="response_file_area mt-3 pb-0">
                            <div className="checklist_img_container">
                              {selectedItemData?.file_list?.map((selectedItemData, index) => (
                                <div
                                  className="note_image_container response_image_container"
                                  key={selectedItemData?.id}
                                >
                                  {selectedItemData?.extension === "pdf" ? (
                                    <div
                                      className="response_doc_file_container"
                                      onClick={() => handleViewDocument(baseURL + selectedItemData?.path!)}
                                    >
                                      <i className="bi bi-file-earmark-pdf"></i>
                                    </div>
                                  ) : (
                                    <Image
                                      src={baseURL + selectedItemData?.path!}
                                      alt={`${index + 1}`}
                                      className="note_img response_image"
                                      preview
                                    />
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Status */}
                <div className="col-12">
                  <div className="page_form_group">
                    <label htmlFor="biResponseStatus" className="custom_form_label is_required">Status</label>

                    <div className="response_status_container px-0">
                      <div className="response_status_grp">
                        <RadioButton
                          inputId="Satisfactory"
                          value={biResponseStatus}
                          onChange={(e: RadioButtonChangeEvent) => setBiResponseStatus("Satisfactory")
                          }
                          checked={biResponseStatus === "Satisfactory"}
                        />
                        <label htmlFor="Satisfactory">
                          Satisfactory
                        </label>
                      </div>
                      <div className="response_status_grp">
                        <RadioButton
                          inputId="Unsatisfactory"
                          value={biResponseStatus}
                          onChange={(e: RadioButtonChangeEvent) => setBiResponseStatus("Unsatisfactory")}
                          checked={biResponseStatus === "Unsatisfactory"}
                        />
                        <label htmlFor="Unsatisfactory">
                          Unsatisfactory
                        </label>
                      </div>
                    </div>

                    {biResponseStatusError &&
                      <small className="form_error_msg">{biResponseStatusError}</small>
                    }
                  </div>
                </div>

                {/* Response note */}
                <div className="col-12">
                  <Textarea
                    id="biResponseNote"
                    label="Response note"
                    labelHtmlFor="biResponseNote"
                    required={false}
                    value={biResponseNote}
                    placeholder="Enter response note"
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setBiResponseNote(e.target.value)}
                    error={biResponseNoteError}
                    formGroupClassName="mb-1"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Mail modal */}
      <Dialog
        header={mailModalHeader}
        footer={mailModalFooter}
        headerClassName="custom_modal_header"
        visible={showMailModal}
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseMailModal}
        dismissableMask
      >
        <div className="custom_modal_body">
          <div className="p-1 p-sm-3 pb-sm-0 w-100">
            <div className="row">
              <div className="col-12">
                <TextInput
                  id="emailAddress"
                  label="E-mail address"
                  labelHtmlFor="emailAddress"
                  required={true}
                  value={emailAddress}
                  placeholder="abcd@gmail.com"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setEmailAddress(e.target.value)
                  }
                  error={emailAddressError}
                  keyFilter={"email"}
                  formGroupClassName="mb-2"
                />

                {planCheckData?.file_download_path !== null && (
                  <div
                    className="file_attached_area"
                    onClick={handleViewReportDocument}
                  >
                    <i className="bi bi-paperclip"></i>
                    <h6>Plan check report.pdf</h6>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}


      {/* Document view modal */}
      <DocumentViewModal
        isOpen={showItemDocViewModal}
        onClose={handleCloseFileViewModal}
        fileUrl={documentFilePath}
      />
      {/*  */}
    </React.Fragment>
  );
};

export default PlanCheckBasic;
